import React, { Component } from 'react';
import Select from 'components/Select';
import InputCalendar from 'components/InputCalendar';
import moment from 'moment';

class Delivery extends Component {
  render() {
    let dataArray = this.props.dataArray || {};
    let emirateArray = dataArray.emirate;
    let emirateSlots = dataArray.emirateSlots;

    let emirate =
      this.props.emirate;
    let slot =
      this.props.slot;
    let deliveryDate =
      this.props.deliveryDate;

    let emirateList = [];

    if (emirateArray) {
      Object.keys(emirateArray).forEach(
        function(value) {
          emirateList.push({
            label: emirateArray[value],
            value: value
          });
        }
      );
    }

    let slotList =
      this.props.slotList || [];

    if (
      slotList.length === 0 &&
      emirate &&
      emirate.value &&
      emirateSlots &&
      emirateSlots[emirate.value]
    ) {
      slotList =
        emirateSlots[emirate.value].map(
          function(item) {
            return {
              label: item.display_name,
              value: item.id
            };
          }
        );
    }

    let newDate = moment().add(
      3,
      'days'
    );

    let renderDay = function(
      props,
      currentDate
    ) {
      if (
        !currentDate.isBetween(
          newDate,
          newDate.clone().add(3, 'months'),
          null,
          '[]'
        )
      ) {
        props.className =
          props.className +
          ' rdtDisabled';
        delete props.onChange;
        delete props.onClick;
      } else if (
        currentDate.isSame(
          deliveryDate || newDate
        )
      ) {
        props.className =
          props.className + ' selected';
      }

      return (
        <td {...props}>
          {currentDate.date()}
        </td>
      );
    };

    return (
      <section
        className="step-form-group"
        id="delivery"
      >
        <div className="goal-heading">
          <div className="goal-number">
            05
          </div>

          <h2>
            Choose start date &amp; delivery
            time window
          </h2>

          <span>05</span>
        </div>

        <div className="delivery-detials">
          <div className="popup-select-area step-form-input">
            <label className="food-prefs-header">
              Start Date
            </label>

            <div className="popup-dash-calendar-fix">
              <InputCalendar
                inputClassName="letter-xs pointer"
                locale="en"
                value={
                  deliveryDate ||
                  newDate.unix()
                }
                dateFormat="YYYY-MM-DD"
                name="deliveryDate"
                renderDay={renderDay}
                onViewModeChange={
                  function() {
                    return false;
                  }
                }
                onChange={
                  this.props.onDateChange
                }
                placeholder="Select start date"
              />
            </div>
          </div>

          <div className="popup-select-area step-form-input">
            <label className="food-prefs-header">
              Emirates
            </label>

            <Select
              multiple={false}
              isgrouped={true}
              placeholder="Select Emirates"
              list={emirateList}
              value={emirate || ''}
              isSearchable={true}
              name="selectedDay"
              onChange={function(
                name,
                value
              ) {
                this.props.onEmirateChange(
                  value
                );
              }.bind(this)}
            />
          </div>

          <div className="popup-select-area step-form-input">
            <label className="food-prefs-header">
              Delivery Time
            </label>

            <Select
              multiple={false}
              isgrouped={true}
              placeholder="Select Delivery Time"
              list={slotList}
              value={slot || ''}
              isSearchable={true}
              name="selectedDay"
              onChange={function(
                name,
                value
              ) {
                this.props.onSlotChange(
                  value
                );
              }.bind(this)}
            />

            <p>
              *Please note the delivery will
              happen any time within the
              selected delivery time window.
            </p>
          </div>
        </div>
      </section>
    );
  }
}

export default Delivery;
